export enum UserAccountType {
    LOCAL = 1
}
